import type { NetworkRule } from "@/hooks/useNetworkRules";

export const logNetworkRules = (rules: NetworkRule[]) => {
  console.log("\n=== All Network Rules ===");
  console.log(`Total: ${rules.length} rules\n`);

  rules.forEach((rule, index) => {
    console.log(`Rule ${index + 1}:`);
    console.log(`  ID: ${rule.id}`);
    console.log(`  Name: ${rule.name}`);
    console.log(`  Type: ${rule.type}`);
    console.log(`  Bundle ID: ${rule.bundleId || 'N/A'}`);
    console.log(`  Description: ${rule.description || 'N/A'}`);
    console.log(`  URLs: ${JSON.stringify(rule.urls || [])}`);
    
    if (rule.parentApp) {
      console.log(`  Parent App:`);
      console.log(`    Name: ${rule.parentApp.name || 'Unknown'}`);
      console.log(`    Bundle ID: ${rule.parentApp.bundleId || 'N/A'}`);
      console.log(`    ID: ${rule.parentApp.id || 'N/A'}`);
    }
    
    if (rule.apps && rule.apps.length > 0) {
      console.log(`  Apps (legacy): ${JSON.stringify(rule.apps)}`);
    }
    
    console.log(`  Last Modified: ${rule.lastModified || 'N/A'}`);
    console.log("");
  });

  // Also log as a table for easier viewing
  console.table(rules.map(r => ({
    id: r.id,
    name: r.name,
    type: r.type,
    bundleId: r.bundleId || 'N/A',
    parentAppName: r.parentApp?.name || 'N/A',
    urlCount: r.urls?.length || 0
  })));
};
